import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { useState, useCallback, useRef } from 'react';
import ToolTip from './ToolTip/ToolTip';
const menuStyles = css `
  .menu {
    box-shadow: 0 0 10px rgb(0 0 0 / 50%);
    margin: 0;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    position: absolute;
    z-index: 99999;
    padding: 2px;
    background-color: white;

    button:hover {
      background-color: #fafafa;
    }
  }

  .menu-cover {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 1;
  }

  .menu-item {
    background-color: transparent;
    border: none;
    border-bottom: 0.55px solid whitesmoke;
    height: 35px;
    outline: outline;
    display: table-cell;
    vertical-align: middle;
    text-align: left;
    padding: 0 10px;

    svg {
      display: inline-block;
    }

    :focus {
      outline: none !important;
    }

    span {
      font-size: 10px;
      padding: 0 10px;
    }
  }
`;
function MenuItem({ icon, label, onClick }) {
    return (_jsxs("button", { type: "button", className: "menu-item", onClick: onClick, children: [icon, _jsx("span", { children: label })] }));
}
function MenuList({ items, boxBounding, onClick }) {
    return (_jsx("div", { className: "menu", style: {
            transform: `translate(${boxBounding.width}px, -${boxBounding.height}px) `,
        }, children: items?.map((item) => {
            return (_jsx(MenuItem, { ...item, onClick: () => onClick(item) }, item.id));
        }) }));
}
export default function MenuButton({ style, component, toolTip = '', className, items = [], onClick = () => null, }) {
    const menuButtonRef = useRef(null);
    const [isShown, showMenu] = useState(false);
    const closeMenuButton = useCallback(() => {
        showMenu(false);
    }, []);
    const handleClick = useCallback(() => {
        showMenu((flag) => !flag);
    }, []);
    const clickHandler = useCallback((e) => {
        showMenu(false);
        onClick(e);
    }, [onClick]);
    return (_jsxs("div", { style: { height: 'auto' }, css: menuStyles, children: [_jsx("button", { ref: menuButtonRef, type: "button", css: style, onClick: handleClick, className: className, style: { boxSizing: 'border-box' }, children: _jsx(ToolTip, { title: toolTip, popupPlacement: "right", children: component }) }), isShown && (_jsx(MenuList, { items: items, boxBounding: menuButtonRef.current?.getBoundingClientRect(), onClick: clickHandler })), isShown && _jsx("div", { className: "menu-cover", onClick: closeMenuButton })] }));
}
